<template>
  <SettingsWrapper @close="$emit('close')" @save="saveCountries">
    <div class="divide-y divide-gray-200 p-6 px-8 py-0">
      <div class="space-y-1">
        <h3 class="text-lg font-medium leading-6 text-gray-900">Shipping costs per country</h3>
        <p class="max-w-2xl text-sm text-gray-500">Enable flat rate or table rate, and create specific shipping costs for each country.</p>
      </div>
      <div class="mt-6">
        <dl class="divide-y divide-gray-200">
          <div class="py-4 sm:grid sm:grid-cols-5 sm:gap-4 sm:py-5">
            <dt class="flex space-x-2 text-sm font-medium text-gray-500">
              <input type="radio" :checked="!enable_tablerate" id="flatrate" class="cursor-pointer h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500" @click="enable_tablerate = false">
              <label class="cursor-pointer" for="flatrate">Flat rate</label>
            </dt>
            <div class="mt-1 sm:mt-0 col-span-4 grid gap-4" :class="enable_tablerate && 'opacity-60 pointer-events-none'">
              <div>
                <label
                  for="port"
                  class="block text-sm font-medium text-gray-700"
                >Shipment cost</label>
                <div class="mt-1  w-full">
                  <input type="text" name="port" id="port" v-model="shipment_price" class="rounded-md block w-full Arounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                </div>
                <span class="text-sm text-gray-600">
                  This shipping price will be used for all addresses, regardless of country origin.
                </span>
              </div>
            </div>
          </div>
          <div class="py-4 sm:grid sm:grid-cols-5 sm:gap-4 sm:py-5">
            <dt class="flex space-x-2 text-sm font-medium text-gray-500">
              <input type="radio" :checked="enable_tablerate" id="tablerate" class="cursor-pointer h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500" @click="enable_tablerate = true">
              <label class="cursor-pointer" for="tablerate">Table rate</label>
            </dt>
            <div class="mt-1 sm:mt-0 col-span-4 grid gap-4" :class="!enable_tablerate && 'opacity-60 pointer-events-none'">
              <div class="flex p-4 relative">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
                <input
                  v-model="search"
                  class="outline-none absolute rounded-xl border border-gray-200 h-full w-full left-0 top-0 pl-12 bg-transparent focus:outline-blue-600"
                  placeholder="Search country"
                  ref="searchEl"
                >
              </div>
              <span class="text-sm text-gray-600">
                Only the the countries with a defined price will be shown to users. Note: <b>Do not</b> set the table rate option without defining any rates.
              </span>
              <div class="border border-gray-200 md:rounded-lg overflow-hidden">
                <div class="h-[400px] overflow-auto">
                  <table class="min-w-full table-fixed divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                    <tr class="divide-x divide-gray-200">
                      <th scope="col" class="w-1/2 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-5">
                        Country
                      </th>
                      <th scope="col" class="w-1/2 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-5">
                        Shipping cost
                      </th>
                    </tr>
                    </thead>
                    <!-- Odd row -->
                    <tbody class="bg-white">
                    <tr
                      v-for="country in (loading ? 13 : searchedCountries)"
                      :key="country.value"

                      class="divide-x divide-gray-200 w-full duration-100 overflow-hidden"
                    >
                      <td class="border-t border-gray-100 py-3.5 pl-4 text-sm font-medium text-gray-900 sm:pl-5 max-w-[6.25rem]">
                  <span :class="loading && 'ske'">
                    <span v-if="loading">aishoten ashitneasihotn thneos</span>
                    <span v-else v-html="country.label"></span>
                  </span>
                      </td>
                      <td
                        class="border-t !border-t-gray-100 text-sm text-gray-500 max-w-[6.25rem]"
                        :class="[loading && 'px-4 py-3.5 sm:pl-5']"
                      >
                        <input
                          v-if="!loading"
                          class="px-4 py-3.5 sm:pl-5 w-full outline-blue-600 border-none"

                          v-model="values[`tax/countries/${country.value}`]"
                        >
                        <span v-else class="ske">ashioet thaeos ashte</span>
                      </td>
                    </tr>
                    </tbody>

                    <!-- More people... -->
                  </table>
                </div>
              </div>
            </div>
          </div>
        </dl>
      </div>
    </div>
  </SettingsWrapper>
</template>

<script>

import SettingsWrapper from "./../SettingsWrapper"
import {mapGetters} from "vuex"

const ENABLE_TABLERATE = 'tax/enable_tablerate'

export default {
  components: {
    SettingsWrapper,
  },
  async created() {
    console.log("website: ", this.website)
    this.extractBaseValues()

    this.loading = true
    const countries = (await this.$store.dispatch("cachedGet", {
      endpoint: `${this.link}/rest/V1/editor/countries`,
      headers: { Cookie: 'environment=editor' },
    })).data || []
    const map = new Set()
    countries.forEach(country => {
      if (!map.has(country.value)) {
        this.countries.push(country)
        map.add(country.value)
      }
    })

    this.countries = this.countries
      .filter(country => country.value)
      .map(country => ({ ...country, label: `${country.label} <span class="text-gray-500">(${country.value})</span>` }))

    this.extractDefaultValues()
    this.loading = false
  },
  data() {
    return {
      loading: true,
      search: "",
      countries: [],
      shipment_price: null,
      enable_tablerate: null,

      values: {},
    }
  },
  methods: {
    extractBaseValues() {
      const storageProperties = JSON.parse(sessionStorage.getItem("country/tax") || "{}")

      this.shipment_price = storageProperties.shipment_price || this.website.shipment_price
      this.enable_tablerate = (storageProperties.properties && storageProperties.properties[ENABLE_TABLERATE]) || this.website.properties[ENABLE_TABLERATE]

      if (this.enable_tablerate === '0') this.enable_tablerate = false
      else if (this.enable_tablerate === '1') this.enable_tablerate = true
    },
    extractDefaultValues() {
      const storageProperties = JSON.parse(sessionStorage.getItem("country/tax") || "{}")

      const getKey = country => `tax/countries/${country.value}`
      this.countries.forEach(country => {
        const key = getKey(country)

        let newVal

        newVal = this.website.properties[key]
        if (newVal == '0') newVal = false
        if (newVal == '1') newVal = true

        if (newVal === undefined) {
          newVal = newVal || storageProperties[key] || ""
        }

        if (newVal) this.values[key] = newVal
      })
      this.countries.sort((a, b) => {
        if (this.values[getKey(a)] && !this.values[getKey(b)]) return -1
        if (!this.values[getKey(a)] && this.values[getKey(b)]) return 1
        return 0
      })
      this.values = { ...this.values }
    },
    async saveCountries() {
      this.loading = true
      try {
        const keys = Object.keys(this.values)
        const details = keys.reduce((all, lang) => ({
          ...all,
          [lang]: (this.values[lang] && this.values[lang]).toUpperCase().replace(/,/g, '.')
        }), {})
        console.log({
          shipment_price: this.shipment_price,
          properties: {
            ...this.website.properties,
            ...details,
            [ENABLE_TABLERATE]: this.enable_tablerate,
          },
        })

        sessionStorage.setItem("country/tax", JSON.stringify(details))
        await this.axios.put(`/api/websites/${this.website.uid}`, {
          shipment_price: this.shipment_price,
          properties: {
            ...this.website.properties,
            ...details,
            [ENABLE_TABLERATE]: this.enable_tablerate,
          },
        })
        this.$store.dispatch('clearCacheSearch', "websites")
        await this.$store.dispatch("toast/success", { message: "Successfully saved country tax settings!" })
      } catch (err) {
        await this.$store.dispatch("toast/handleError", err)
      }
      this.loading = false
    },
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
      context: 'editor/context',
      website: 'editor/website',
    }),

    computedValues() {
      const values = this.values
      return Object.keys(values).reduce((all, country) => ({
        ...all,
        [country]: (values[country] + '').replace(/\,/, '.')
      }), {})
    },
    searchedCountries() {
      const search = this.search || ""
      if (!search) return this.countries

      return this.countries.filter(country => country.label.toLowerCase().includes(search.toLowerCase()))
    },
  },
}

</script>
